const $t = key =>
  typeof window !== "undefined" && window.$t ? window.$t(key) : key;

export default function createDataJs() {
  return {
    tabList: [
      {
        title: $t("page.content.all"),
        key: 1,
        img: require("@/basa/assets/images/gg1.png")
      },
      {
        title: $t("page.content.material"),
        key: 2,
        img: require("@/basa/assets/images/gg2.png")
      },
      {
        title: $t("page.content.equipment"),
        key: 3,
        img: require("@/basa/assets/images/gg3.png")
      },
      {
        title: $t("page.content.otherServices"),
        key: 4,
        img: require("@/basa/assets/images/gg4.png")
      },
      {
        title: $t("page.content.engineeringSubcontracting"),
        key: 5,
        img: require("@/basa/assets/images/gg5.png")
      }
      // {
      //   title: $t('page.content.engineeringServiceInProgress'),
      //   key: 6,
      //   img: require("@/basa/assets/images/gg6.png")
      // }
    ]
  };
}
